exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes blink{0%{opacity:.2}20%{opacity:1}to{opacity:.2}}@keyframes blink{0%{opacity:.2}20%{opacity:1}to{opacity:.2}}.typing{margin-top:-18px;color:#717577}.typing a{color:#717577;font-weight:700}.typing a:focus,.typing a:hover{text-decoration:underline}.dots{font-size:30px}.typing span{-webkit-animation-name:blink;animation-name:blink;-webkit-animation-duration:1.4s;animation-duration:1.4s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-fill-mode:both;animation-fill-mode:both}.typing span:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s}.typing span:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.typing .text{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bf90556","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Typing.vue
// module id = tIy2
// module chunks = 0